import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "contexts/AuthContext";
import { logoutUser } from "services/users";

// components
import CardLogin from "components/Cards/Auth/CardLogin.js";
import FooterAuth from "components/Footers/Auth/FooterAuth.js";
// texts
import cardlogin from "_texts/auth/cards/cardlogin.js";
import footerauth from "_texts/auth/footers/footerauth.js";

const Login = () => {
  const location = useLocation();
  const searchParams = useSearchParams();
  const { activeUser, setActiveUser, error } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams[0].get("logout")) {
      logoutUser();
      setActiveUser(null);
      navigate("/");

    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (activeUser) {
      const redirectPath = localStorage.getItem("redirectPath");
      if (redirectPath) {
        localStorage.removeItem("redirectPath");
        navigate(redirectPath);
      } else {
        navigate("/");
        /*if (activeUser.user_type.match(/client/)) {
        } else {
          navigate("/dashboard");
        }*/
      }
    }
  }, [activeUser, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  console.log("!!! INSIDE LOGIN");

  return (
    <>
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-black bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("assets/img/bg-agentwire2.png").default + ")",
            }}
          ></div>
          <div className="container mx-auto px-4 h-full">
            <div className="flex content-center items-center justify-center h-full">
              <div className="w-full lg:w-4/12 px-4">
                <CardLogin error={error} {...cardlogin} />
              </div>
            </div>
          </div>
          <FooterAuth {...footerauth} />
        </section>
      </main>
    </>
  );
};

export default Login;
